export default {
  TEMPERATURE: 'temperature',
  PRESSURE: 'pressure',
  POSITION: 'position',
  PRECISE_POSITION: 'precise_position',
  SPEED: 'speed',
  CONFIG: 'config',
  STATUS: 'status'
};
